import { PaginateResult } from "core/resources/types/shared";
import http from "infra/http";
import { useQuery } from "react-query";
import { ListagemReservaResponse, ReservaFiltroAdv } from "../typings";

function useReservas(filtro: ReservaFiltroAdv, enabled = true) {
  return useQuery(
    [
      `/v1/reserva`,
      filtro
    ],
    async () => {
      const { data } = await http.get<PaginateResult<ListagemReservaResponse>>(
        `/v1/reserva`,
        {
          params: filtro,
        }
      );
      return data;
    },
    {
      enabled,
    }
  );
}

export default useReservas;
